/* eslint-disable max-len */
import useMediaQuery from './useMediaQuery';

/**
  * Breakpoints of screen types portal service support (also defined in variables.scss)
  */
const BREAKPOINTS = {
  LARGE_DESKTOP: 1440,
  MEDIUM_DESKTOP: 1025,
  TABLET: 600,
};

const useDevice = () => {
  const isPhone = useMediaQuery(`(max-width: ${BREAKPOINTS.TABLET - 1}px)`);
  const isTablet = useMediaQuery(`(min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${BREAKPOINTS.MEDIUM_DESKTOP - 1}px)`);
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.MEDIUM_DESKTOP - 1}px)`);
  const isLargeDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS.LARGE_DESKTOP}px)`);
  const isMediumDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS.MEDIUM_DESKTOP}px) and (max-width: ${BREAKPOINTS.LARGE_DESKTOP - 1}px)`);
  const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS.MEDIUM_DESKTOP}px)`);

  return {
    isPhone,
    isTablet,
    isMobile,
    isMediumDesktop,
    isLargeDesktop,
    isDesktop,
  };
};

export default useDevice;
